// src/pages/HomePage.jsx
import React from 'react';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';
import HeroSection from '../components/sections/HeroSection';
import StatsSection from '../components/sections/StatsSection';
import PricingSection from '../components/sections/PricingSection';
import ProductAnalysisSection from '../components/sections/ProductAnalysisSection';
import FAQSection from '../components/sections/FAQSection';
import CTActionSection from '../components/sections/CTActionSection';
import '../styles/pages/HomePage.css';

const HomePage = () => {
  return (
    <div className="home-page">
      <Header />
      <main className="home-main">
        <HeroSection />
        <StatsSection />
        <PricingSection />
        <ProductAnalysisSection />
        <FAQSection />
        <CTActionSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;